// extracted by mini-css-extract-plugin
export default {"divPrincipal":"BuscaProf_divPrincipal__sDBUH","divInput":"BuscaProf_divInput__NzxBf","buttonBusca":"BuscaProf_buttonBusca__ZcWA2","procurar":"BuscaProf_procurar__tGT1L"};